<template>
  <div id="map" class="min-h-[300px] w-full"/>
</template>

<script setup>
import mapdata from "@/maps/mapdata"
import mapinfo from "@/maps/mapinfo"
import usmap from "@/maps/usmap"
import { onMounted } from "vue"
import { percent } from "@/support"

const props = defineProps({
  states: Object,
  year1: Number,
  year2: Number,
})

const getColor = change => {
  if (change < -40) {
    return "rgba(230,97,1,1)"
  }

  if (change < -30) {
    return "rgba(233,119,22,1)"
  }

  if (change < -20) {
    return "rgba(237,141,43,1)"
  }

  if (change < -10) {
    return "rgba(241,163,64,1)"
  }

  if (change < -5) {
    return "rgba(245,193,127,1)"
  }

  if (change < -1) {
    return "rgba(250,224,191,1)"
  }

  if (change < 1) {
    return "rgba(247,247,247,1)"
  }

  if (change < 5) {
    return "rgba(221,217,235,1)"
  }

  if (change < 10) {
    return "rgba(187,179,215,1)"
  }

  if (change < 20) {
    return "rgba(153,142,195,1)"
  }

  if (change < 30) {
    return "rgba(123,101,174,1)"
  }

  if (change > 30) {
    return "rgba(94,60,153,1)"
  }

  return "rgb(0,0,0)"
}

onMounted(() => {
  const state_specific = {}

  for (const code in props.states) {
    const enrollments = props.states[code].data
    const first = enrollments[0]
    const last = enrollments[enrollments.length - 1]
    const firstValue = parseInt(first.enr)
    const lastValue = parseInt(last.enr)

    const change = percent(lastValue - firstValue, firstValue)
    const bg = getColor(change)
    const color = bg

    state_specific[code] = {
      name: first.name,
      change,
      color,
      bg,
      hide: "no",
      code,
      hover_color: bg,
      description: change ? `${firstValue} 1Ls in ${props.year1} <br/> ${lastValue} 1Ls in ${last.admission_year} <br/>  ${change}% ` : "",
    }
  }

  state_specific.AK = {
    hide: "yes",
  }

  usmap.mapdata = {
    ...mapdata,
    main_settings: {
      ...mapdata.main_settings,
    },
    state_specific,
  }

  usmap.mapinfo = mapinfo

  usmap.load()
})
</script>
